<!--element 实时事件-->
<template>
  <div class="myrealTime">
    <div class="con">

      <div class="mytable">
        <div class="Files-top">
          <div class="ic-left">
            <span>实时事件</span>
          </div>
          <div class="btns">
          </div>
        </div>
        <el-table :data="msgList" style="width: 100%;margin-top:20px" border :height="tabHeights">
          <el-table-column label="序号" width="90" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkObject" label="关联对象" width="300">
          </el-table-column>
          <!-- <el-table-column prop="eventlevel" label="等级" width="130" align="center" :formatter="formatEventLevel">
        </el-table-column> -->
          <el-table-column label="等级" min-width="105" align="center">
            <template #default="{row}">
              <div class="public-flex">
                <p class="myemergent mutongyong" v-if="row.eventlevel =='0'">消息</p>
                <p class="myhigh mutongyong" v-if="row.eventlevel =='1'">预警</p>
                <p class="mystandard mutongyong" v-if="row.eventlevel =='2'">告警</p>
                <p class="mylow mutongyong" v-if="row.eventlevel =='3'">通知</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="类型" width="130">
          </el-table-column>
          <el-table-column prop="eventtime" label="时间">
            <template slot-scope="scope">{{ scope.row.eventtime | date_format }}</template>
          </el-table-column>
          <el-table-column prop="description" label="内容" width="550">
          </el-table-column>
          <!-- <el-table-column prop="eventstate" label="状态" :formatter="formatterEventState" align="center">
        </el-table-column> -->
          <el-table-column label="状态" width="105" align="center">
            <template #default="{row}">
              <div class="patrol public-flex" v-if="row.eventstate =='3'">
                <p></p><span>已确认</span>
              </div>
              <div class="overhaul public-flex" v-else>
                <p></p><span>未处理</span>
              </div>

            </template>
          </el-table-column>
          <!-- <el-table-column prop="confirmuser" label="确认人">
        </el-table-column>
        <el-table-column prop="confirmtime" label="确认时间" :formatter="formatTimeConfirm">
        </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        form: {
          eventType: "",
          dataTime: [new Date(),new Date()],
        },
        tabHeights: document.getElementById('app').clientHeight-190,
        eventList: [],
        state: -1,
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        loading: false,
        filterStatus: false,
      }
    },
    created () {},
    mounted () {
      debugPage=this
      //默认全选
      this.form.eventType[0]="全选"
      console.log(this.$store,'this.$store.socketStore');
      this.selectAll();
      this.searchEvents()
    },
    destroyed () {},
    computed: {
      eventStore () {
        return this.$store.eventStore
      },
      getEventTypes () {
        return this.eventStore.getters.searchAllEventTypes
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getLevelName () {
        return this.$store.eventStore.getters.getLevelName
      },
      getStateName () {
        return this.$store.eventStore.getters.getStateName
      },
      msgList () {
        //只保留最新的100条消息，而且刷新就移除
        var list=this.$store.socketStore.state.msgList.filter((item,index) => index<100)
        // console.log("未读信息",list);
        if(this.filterStatus) {
          return list.filter(item => {
            console.log("item.hasOwnProperty('unReaded')",item.hasOwnProperty('unReaded'));
            return item.hasOwnProperty('unReaded')
          })
        } else {
          console.log("list",list);
          return list
        }
      },
    },
    watch: {
      eventList (nv,ov) {

      }
    },
    methods: {
      formatEventLevel (row,column,cellValue) {
        return this.getLevelName(row.eventlevel)
      },
      formatterEventState (row,column,cellValue) {
        return this.getStateName(row.eventstate)
      },
      formatTime (row,column,cellValue) {
        return new Date(row.time).format('yyyy/MM/dd hh:mm:ss')
      },
      formatTimeConfirm (row,column,cellValue) {
        if(!isempty(row.confirmtime)) {
          return new Date(row.confirmtime).format('yyyy/MM/dd hh:mm:ss')
        }
      },
      selectAll () {
        if(this.form.eventType[0]=="全选") {
          this.getEventTypes.forEach(item => {
            this.form.eventType.push(item.no)
          })
        } else {
          this.form.eventType=[]
        }
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.searchEvents()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.searchEvents()
      },
      confirmEvent (row) {
        //确认事件
        this.$api.eventApi.confirmEventByEventNo(row.deviceNo,respon => {
          this.$message.success("确认成功")
          this.searchEvents()
        },respon => {
          this.$message.warning("确认失败")
        })
      },
      searchEvents () {
        //查询事件
        if(isempty(this.form.eventType)) {
          //事件类型为空
          this.$message.warning("事件类型不能为空")
          return
        }
        let eventTypeNos=""
        //bgTime变成0点0秒
        let y=this.form.dataTime[0].getFullYear();
        let m=this.form.dataTime[0].getMonth();
        let d=this.form.dataTime[0].getDate();
        let bgTime=new Date(y,m,d).getTime();
        //let bgTime = this.form.dataTime[0].getTime()
        //把0点0分变成23点59
        let endTime=this.form.dataTime[1].getTime()+60*60*24*1000-1
        this.form.eventType.forEach((item,index) => {
          if(item!="全选") {
            index+1<this.form.eventType.length? eventTypeNos+=item+",":eventTypeNos+=item
          }
        })
        this.loading=true
        this.$api.eventApi.searchEventListByUser(undefined,this.nowUnit.id,eventTypeNos,this.state,-1,getValueIfNoNull(this.nowDevice,{}).no,bgTime,endTime,this.pageIndex,this.pageSize,'',respon => {
          this.total=respon.total
          this.eventList=respon.data
          this.loading=false
        })
      },
    },
    //过滤器
    filters: {
      //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
      energyType (val) {
        if(val=='ELECTRIC') {
          return "电"
        } else if(val=='WATER') {
          return "水"
        } else {
          return "气"
        }
      },
      //单位类型
      company (val) {
        if(val=='351') {
          return "尖"
        } else if(val=='352') {
          return "峰"
        } else if(val=='353') {
          return "平"
        } else if(val=='354') {
          return "谷"
        } else if(val=='1000') {
          return "总"
        }
      },
      //阶梯名称
      sectionNameFun (val) {
        if(val=='第1阶梯') {
          return "第一阶梯"
        } else if(val=='第2阶梯') {
          return "第二阶梯"
        } else if(val=='第3阶梯') {
          return "第三阶梯"
        } else {
          return val
        }
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  }
</script>

<style scoped lang='scss'>
  .myrealTime {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .mytable {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 12px 20px 20px 20px;
        background-color: #fff;
      }
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .mutongyong {
      width: 36px;
      height: 20px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }

    //消息
    .myemergent {
      border: 1px solid #2981D2;
      color: #2981D2;
      background-color: #DEF3FF;
    }

    //预警
    .myhigh {
      border: 1px solid #FF7C1D;
      color: #FF7C1D;
      background-color: #FFF1E7;
    }

    //告警
    .mystandard {
      border: 1px solid #ED6547;
      color: #ED6547;
      background-color: #FFECEC;
    }

    //通知
    .mylow {
      border: 1px solid #0DAE88;
      color: #0DAE88;
      background-color: #8EF9DF;
    }
  }
</style>